import { useMatches } from '@remix-run/react';

import type { RootLoaderData } from '~/rootLoader';

export default function useQsParams() {
  const root = useMatches()[0]!.data as RootLoaderData;

  return root.qsParams;
}
